import React from 'react';

import { Celulares, AppleStore, GooglePlay } from '~/assets/images';

import * as S from './styles';

const RedirectToMobile = () => {
  return (
    <S.Container>
      <S.CellPhonesContainer>
        <img src={Celulares} alt="Celulares com o aplicativo do IB" />
      </S.CellPhonesContainer>

      <S.DataContainer>
        <h1>Parabéns!</h1>
        <h3>O seu cadastro foi feito com sucesso.</h3>
        <p>Clique para fazer o</p>
        <h2>DOWNLOAD</h2>

        <S.LinksContainer>
          <a
            href="https://apps.apple.com/br/app/ib-app-solu%C3%A7%C3%B5es-inteligentes/id1632321727"
            target="_blank"
            rel="noreferrer"
          >
            <img src={AppleStore} alt="Link para a Apple Store" />
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=br.com.ib&hl=pt_BR&gl=US"
            target="_blank"
            rel="noreferrer"
          >
            <img src={GooglePlay} alt="Link para a Google Play" />
          </a>
        </S.LinksContainer>
      </S.DataContainer>
    </S.Container>
  );
};

export default RedirectToMobile;
